import React, { useEffect, useState } from "react";
import TableHeader from "../../common/table/TableHeader";
import TableSkeleton from "../../common/table/TableSkeleton";
import handleError from "../../../constant/handleError";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import useShowAlert from "../../../utils/AlertUtiles";
import axiosInstance from "../../../utils/AxiosInstance";
import ReactPaginate from "react-paginate";
import DateConverter from "@heartinz/date_and_time_processor";
import Viewbooking from "./Viewbooking";
import ViewInterest from "../interest/ViewInterest";
import uRLs from "../../../utils/baseUtils";
import { capitalizeFirstLetter } from "../../../utils/helper";

const allHeaders = [
  "S.No",  
  "Booking / Enquiry No",
  "Name",
  "Phone",
  "State",
  "District",
  "Created On",
  "Work Date",
  "No Of Acres ",
  "Amount",
  "Status",
  // "Payment Status ",
  // "Action",
   "Captain", 
];

function Booking() {
  const [loading, setLoading] = useState({
    addPayment: false,
    list: false,
    upadteBooking: false,
    status:false,
    foAssessment:false,
    assignGLList:false,
    assignGLBtn:false,
    updateStartDate:false,
    cancelBooking:false,
    finalImage:false,
    measureLoad:false,
    confirmBooking:false,
    bookingComplete:false,
    initialteRefund:false,
    verifyRefund:false,
    viewBooking:false
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [activeStatus, setActiveStatus] = useState("All");
  const [isBookingData, setBooking] = useState([]);
  const [isSelectedData, setSelectedData] = useState({});
  const [isViewModelOpen, setViewModalOpen] = useState(false);
  const [isEnquiryModalOpen, setEnquiryModalOpen] = useState(false);
 const [isOpen, setOpen] = useState(false);
  const STATUS_TABS = ["All", "Enquiries", "Placed", "Order processing",];
  const showAlert = useShowAlert();

  const headers = activeStatus === "All"
  ? allHeaders
  : allHeaders.filter(header => header !== "Status");

  const hadlelistBooking = async (page = 0) => {
    setLoading((prev) => ({ ...prev, list: true }));
    checkNetworkStatus();

    try {
      let endpoint = "";
       if (activeStatus === "All")
        endpoint = `farmerbooking/admin/list?pageno=${page + 1}&limit=${
          uRLs.PER_PAGE
        }&type=all`;
      if (activeStatus === "Enquiries")
        endpoint = `farmerbooking/admin/list?pageno=${page + 1}&limit=${
          uRLs.PER_PAGE
        }&bookingStatus=ENQUIRY`;
      if (activeStatus === "Order processing")
        endpoint = `farmerbooking/admin/list?pageno=${page + 1}&limit=${
          uRLs.PER_PAGE
        }&bookingStatus=ACCEPTED`;
      if (activeStatus === "Placed")
        endpoint = `farmerbooking/admin/list?pageno=${page + 1}&limit=${
          uRLs.PER_PAGE
        }&bookingStatus=PLACED`;
        
      const response = await axiosInstance.get(endpoint);
      if (
        response &&
        response?.data?.status &&
        response?.data?.results?.length > 0
      ) {
        setBooking(response?.data?.results);
      } else {
        setBooking([]);
      }

      if (response?.data?.results?.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response?.data.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      setBooking([]);
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, list: false }));
    }
  };

  useEffect(() => {
    hadlelistBooking(currentPage);
  }, [currentPage, activeStatus]);

  const handleViewBooking = async (item) => {  
     setLoading((prev) => ({ ...prev, viewBooking: true }));
    try {
       checkNetworkStatus();
      const response = await axiosInstance.get(
        `farmerbooking/admin/details/${item._id}`
      );
      setSelectedData(response.data.results);
      // setStatusHistory(response?.data?.results?.bookingStatusHistory)
      // Enquiries are view-only, so they open the read-only enquiry modal
      // instead of the booking modal with its payment and assignment actions.
      if (response?.data?.results?.lastStatus === "ENQUIRY") {
        // ViewInterest reads its timeline from statusHistory[{ status, role, time }].
        setSelectedData({
          ...response.data.results,
          statusHistory: (response.data.results.bookingStatusHistory || []).map((h) => ({
            ...h,
            status: h.bookingTracking,
            role: h.entryBy,
          })),
        });
        setEnquiryModalOpen(true);
      } else {
        setViewModalOpen(true);
      }
    } catch (error) {
      handleError(error, showAlert);
    }finally{
           setLoading((prev) => ({ ...prev, viewBooking: false }));
    }
  };
  const handleOpen=()=>{
     setOpen(true)
  }
   const handleClose=()=>{
      setOpen(false)
  }
  const handleCloseViewBooking = async () => {
    setViewModalOpen(false);   
  };
  const handleCloseViewEnquiry = () => {
    setEnquiryModalOpen(false);
  };
  const handleApprove = async (bookingId) => {
    try {
      setLoading((prev) => ({ ...prev, status: bookingId }));

      const response = await axiosInstance.patch(
        `farmerbooking/admin/status/${bookingId}`
      );
      if (response?.data?.status) {
        showAlert("success", response?.data?.message);
         const updatedBookingData = response.data.results;
        setBooking((prevData) => {
          if (activeStatus === "Placed") {
            setTotalItems((prev) => prev - 1);

            return prevData.filter((p) => p._id !== bookingId);
          }

          return prevData.map((booking) => {
          if (booking._id === bookingId) {            
            return {
              ...booking,
            lastStatus: response?.data?.results?.lastStatus, 
             bookingStatus: response?.data?.results?.bookingStatus,
            // bookingStatusHistory: response?.data?.results?.bookingStatusHistory
            };
          }
          return booking;
        });
        });
        if (isBookingData.length === 1 && currentPage > 0) {
          setCurrentPage((prev) => prev - 1);
        }  
        if (isSelectedData?._id === bookingId) {
        setSelectedData((prevSelected) => ({
          ...prevSelected,
          lastStatus: updatedBookingData.lastStatus,
          bookingStatus: response?.data?.results?.bookingStatus,
             bookingStatusHistory: [
            ...(prevSelected.bookingStatusHistory || []),
            {
              bookingTracking: updatedBookingData.lastStatus,
              entryBy: "Owner",
              time: updatedBookingData.updatedAt
            }
          ]
        }));
      }      
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, status: false }));
    }
  };
 
  return (
    <div>
      <div className=" pe-3">
        <div class="breadcrumb-title pe-3 mb-2">Bookings & Enquiries</div>
      </div>
      <div className="mb-3">
        {STATUS_TABS.map((tab) => (
          <button
            key={tab}
            onClick={() => {
              if (activeStatus !== tab) {
                setCurrentPage(0);
              }
              setActiveStatus(tab);
            }}
            className=" me-1 cursor-poInter"
            style={{
              padding: "10px 15px",
              border: "none",
              fontWeight: activeStatus === tab ? "bold" : "normal",
              borderBottom:
                activeStatus === tab
                  ? "2px solid blue"
                  : "2px solid transparent",
              backgroundColor: "transparent",
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="col-col-12 ">
        <div className="card mb-0">
          <div className="card-body p-0">
            <div className="table-responsive scrollable-table-container">
              <table className="table align-middle mb-0  ">
                <TableHeader headers={headers} />

                <tbody>
                  {loading.list ? (
                    <TableSkeleton
                      rows={5}
                      columns={activeStatus === "All" ?[100,100, 100, 100,100, 100, 100,  100,100,100, 100,100]:[100,100,100,100, 100, 100, 100,100, 100, 100, 100,]}
                    />
                  ) : Array.isArray(isBookingData) &&
                    isBookingData.length > 0 ? (
                    isBookingData.map((item, index) => (
                      <tr
                        key={item._id || index}
                        onClick={() => {
                          handleViewBooking(item);
                        }}
                        className="position-relative  cursor-poInter hover-row"
                      >
                      <td className="text-center">{totalItems - (currentPage * uRLs.PER_PAGE + index)}</td>  
                      <td className="text-center">{item?.bookingNumber}</td>  
                       <td className="text-center">{capitalizeFirstLetter(item?.name)||"-"}</td>  
                        <td>
                          <p className="mb-0 text-center fw-bold">
                            {/* <a href={`tel:+91${item?.mobileNumber}`} className="text-black"> */}
                            {item?.mobileNumber}
                            {/* </a> */}
                          </p>
                        </td>
                        <td className="text-center">
                          {capitalizeFirstLetter(item?.state)}
                        </td>
                        <td className="text-center">
                          {capitalizeFirstLetter(item?.district)}
                        </td>
                           <td className="text-center">
                          <div className="">
                            <p className="mb-0">
                              {item?.createdAt
                                ? DateConverter.ISOToDisplayFormat(
                                    DateConverter.convertToTimeZone(
                                      item?.createdAt,
                                      uRLs.TIMEZONE
                                    )
                                  ).date || ""
                                : "-"}
                            </p>
                          </div>
                        </td> 
                        <td className="text-center">
                          <div className="">
                            <p className="mb-0">
                              {item?.workStartDate
                                ? DateConverter.ISOToDisplayFormat(
                                    DateConverter.convertToTimeZone(
                                      item?.workStartDate,
                                      uRLs.TIMEZONE
                                    )
                                  ).date || ""
                                : ""}
                            </p>
                          </div>
                        </td>
                        <td className="text-center">
                          <span class="badge rounded-pill bg-label-fall">
                            {item?.numberOfAcres}
                          </span>
                        </td>
                        <td>
                          <div className="text-center">
                            <p className="mb-0 fw-bold">
                              ₹
                              {
                                item?.totalAmount || 0
                              }
                            </p>
                          </div>
                        </td>
                          {activeStatus === "All" && (
                        <td className="text-center">
  <span
    className={`app-badge ${
      item?.lastStatus === "ENQUIRY"
        ? "bg-label-infoss"
        : item?.lastStatus === "PLACED"
        ? "bg-label-warning"
        : item?.lastStatus === "ACCEPTED"
        ? "bg-label-spring"
        : item?.lastStatus === "GLMEASUREMENTDONE"
        ? "bg-label-spring"
          : item?.lastStatus === "BOOKINGCOMPLETED"
        ? "bg-label-spring"
        : item?.lastStatus === "FOALLOCATED"
        ? "bg-label-fall"
        : item?.lastStatus === "FOASSESSMENTDONE"
        ? "bg-label-deep-purple"
        : item?.lastStatus === "ADVANCEPAID"
        ? "bg-label-moon"
        : item?.lastStatus === "ADVANCEPENDING"
        ? "bg-label-infoss"
        : item?.lastStatus === "PAYMENT"
        ? "bg-label-moon"
         : item?.lastStatus === "REFUND"
      ? "bg-label-danger"
         : item?.lastStatus === "WORKCOMPLETED"
        ? "bg-label-moon"
        : item?.lastStatus === "BOOKINGCONFIRMED"
        ? "bg-label-success"
          : item?.lastStatus === "WORKINPROGRESS"
        ? "bg-label-infoss"
        : item?.lastStatus === "CANCELLED"
        ? "bg-label-danger"
        : "bg-secondary"
    }`}
  >
    {item?.lastStatus === "ENQUIRY"
      ? "Enquiry"
      : item?.lastStatus === "PLACED"
      ? "Placed"
      : item?.lastStatus === "ACCEPTED"
      ? "Order processing"
        : item?.lastStatus === "MGLMEASUREMENTDONE"
      ? "Measurement Done"
      : item?.lastStatus === "FOALLOCATED"
      ? "FO Allocated"
      : item?.lastStatus === "FOASSESSMENTDONE"
      ? "FO Assessment Done"
      : item?.lastStatus === "ADVANCEPAID"
      ? "Advance Paid"
      : item?.lastStatus === "ADVANCEPENDING"
      ? "Advance Pending"
        : item?.lastStatus === "WORKINPROGRESS"
      ? "Work In Progres"
      : item?.lastStatus === "PAYMENT"
      ? "Payment"
      : item?.lastStatus === "BOOKINGCONFIRMED"
      ? "Booking Confirmed"
       : item?.lastStatus ==="GLMEASUREMENTDONE"
       ?" Measurement Done"
          : item?.lastStatus ==="GLMEASUREMENTPENDING"
       ?" Measurement Pending"
        : item?.lastStatus === "WORKCOMPLETED"
      ? "Work Completed"
       : item?.lastStatus === "BOOKINGCOMPLETED"
      ? "Booking Completed"
      	
      : item?.lastStatus === "CANCELLED"
      ? "Cancelled"
      : item?.lastStatus || "Unknown"}
  </span>
  {item?.currentDimensionChangeStatus === "PENDING_FARMER" && (
    <span className="app-badge bg-label-infoss d-block mt-1" style={{ fontSize: "10px" }}>
      Dimension change: awaiting farmer
    </span>
  )}
  {item?.currentDimensionChangeStatus === "PENDING_ADMIN" && (
    <span className="app-badge bg-label-warning d-block mt-1" style={{ fontSize: "10px" }}>
      Dimension change: needs your approval
    </span>
  )}
</td>
                          )}

                        {/* <td className="text-center">
                          {item?.paymentStatus === "UNPAID" && (
                            <div className="card-lable bg-label-blue bg-opacity-10 d-inline-block">
                              <p className=" mb-0">Unpaid</p>
                            </div>
                          )}
                          {item?.paymentStatus === "PAID" && (
                            <div className="card-lable bg-success text-success bg-opacity-10 d-inline-block">
                              <p className="text-success mb-0">Paid</p>
                            </div>
                          )}
                        </td> */}
                        {/* <td className="text-center">
                          <div className=" d-flex justify-content-center order-actions">
                            <button
                              type="button"
                              className="btn-label-primary shadow-none me-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOpen();
                              }}
                            >
                              <i className="lni lni-eye"></i>
                            </button>
                          </div>
                        </td> */}
                        <td className="text-center">
                        {item?.assignedTo
                          ? <span className="app-badge bg-label-navy">Assigned</span>
                          : "-"
                        }
                      </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={headers.length} className="text-center p-2 text-muted">
                        <span className="text-muted">
                          No bookings or enquiries available .
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>{" "}
            {totalPages > 0 && (
              <div className="d-flex justify-content-center mt-3">
                <ReactPaginate
                  previousLabel={"← Previous"}
                  nextLabel={"Next →"}
                  breakLabel={"..."}
                  onPageChange={({ selected }) => {
                    setLoading((prev) => ({ ...prev, list: true }));
                    setCurrentPage(selected);
                  }}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  containerClassName="pagination"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  activeClassName="active"
                  forcePage={currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {isViewModelOpen && (
        <Viewbooking
          onClose={handleCloseViewBooking}
          isSelectedData={isSelectedData}
          setSelectedData={setSelectedData}                    
          setBooking={setBooking}
          onApprove={handleApprove}
          loading={loading} 
          setTotalItems={setTotalItems}
          setLoading={setLoading}
          activeStatus={activeStatus}
          handleOpen={handleOpen}
          isOpen={isOpen}
          isModelClose={handleClose}
          handleViewBooking={handleViewBooking}
        />
      )}
      {isEnquiryModalOpen && (
        <ViewInterest
          onClose={handleCloseViewEnquiry}
          isSelectedData={isSelectedData}
          setSelectedData={setSelectedData}
          setBooking={setBooking}
        />
      )}
     
    </div>
  );
}

export default Booking;
